var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showFilters,
          expression: "showFilters"
        }
      ]
    },
    [
      _c(
        "FormFieldsContainer",
        [
          _vm.categoriaUsuario === "Interno"
            ? _c(
                "v-flex",
                { attrs: { sm3: "", md3: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.empresa.label,
                      items: _vm.listaEmpresas,
                      "item-text": "nombre",
                      "item-value": "id"
                    },
                    model: {
                      value: _vm.formFields.empresa.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.empresa, "value", $$v)
                      },
                      expression: "formFields.empresa.value"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-select", {
                attrs: {
                  label: _vm.formFields.tipoDTE.label,
                  items: _vm.listaTipoDocumentos,
                  "item-text": "nombre",
                  "item-value": "id"
                },
                model: {
                  value: _vm.formFields.tipoDTE.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.tipoDTE, "value", $$v)
                  },
                  expression: "formFields.tipoDTE.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-select", {
                attrs: {
                  label: _vm.formFields.estado.label,
                  items: _vm.listaEstados,
                  "item-text": "nombre",
                  "item-value": "nombre"
                },
                model: {
                  value: _vm.formFields.estado.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.estado, "value", $$v)
                  },
                  expression: "formFields.estado.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showFilters,
                  expression: "!showFilters"
                }
              ],
              attrs: { sm2: "", md2: "" }
            },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.folio.label,
                  "single-line": "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.formFields.folio.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.folio, "value", $$v)
                  },
                  expression: "formFields.folio.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showFilters,
                  expression: "!showFilters"
                }
              ],
              attrs: { sm2: "", md2: "" }
            },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.cantidadRegistros.label,
                  "single-line": "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.formFields.cantidadRegistros.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.cantidadRegistros, "value", $$v)
                  },
                  expression: "formFields.cantidadRegistros.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm2: "", md2: "" } },
            [
              _c("DatePicker", {
                attrs: {
                  label: _vm.formFields.fechaDesde.label,
                  "error-messages": _vm.errors.collect(
                    _vm.formFields.fechaDesde.id
                  ),
                  id: _vm.formFields.fechaDesde.id,
                  min: _vm.fechaMinima,
                  max: _vm.fechaMaximaInicio.format("YYYY-MM-DD"),
                  type: _vm.formFields.fechaDesde.type,
                  format: _vm.formFields.fechaDesde.format
                },
                model: {
                  value: _vm.formFields.fechaDesde.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.fechaDesde, "value", $$v)
                  },
                  expression: "formFields.fechaDesde.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm2: "", md2: "" } },
            [
              _c("DatePicker", {
                attrs: {
                  label: _vm.formFields.fechaHasta.label,
                  "error-messages": _vm.errors.collect(
                    _vm.formFields.fechaHasta.id
                  ),
                  id: _vm.formFields.fechaHasta.id,
                  min: _vm.fechaMinima,
                  max: _vm.fechaMaximaInicio.format("YYYY-MM-DD"),
                  type: _vm.formFields.fechaHasta.type,
                  format: _vm.formFields.fechaHasta.format
                },
                model: {
                  value: _vm.formFields.fechaHasta.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.fechaHasta, "value", $$v)
                  },
                  expression: "formFields.fechaHasta.value"
                }
              })
            ],
            1
          ),
          _c("v-flex", { attrs: { sm2: "", md2: "" } }, [
            _c(
              "div",
              { staticClass: "text-sm-center botones-filtros" },
              [
                _c(
                  "v-btn",
                  { on: { click: _vm.handleBuscarClick } },
                  [
                    _c("v-icon", [_vm._v("search")]),
                    _vm._v("Filtrar\n        ")
                  ],
                  1
                ),
                _c(
                  "v-btn",
                  { on: { click: _vm.clearFilters } },
                  [_c("v-icon", [_vm._v("clear")]), _vm._v("Limpiar ")],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }